export const SERVICES = [
  {
    slug: "garage-door-repair",
    name: "Garage Door Repair",
    shortDesc: "We fix broken doors fast, any make or model.",
    icon: "Wrench",
    image:
      "https://images.unsplash.com/photo-1739203469638-d6f54c24a5da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxnYXJhZ2UlMjBkb29yJTIwcmVwYWlyJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3Nzc1Njg0MTR8MA&ixlib=rb-4.1.0&q=85",
    metaTitle: "Garage Door Repair Toronto & GTA | Fast Response",
    metaDescription:
      "Garage door off track, damaged, or not opening? GTA Garage Doors sends a licensed tech to your home fast. Call now - same-day service available.",
    intro:
      "A broken garage door isn't a minor annoyance - it's a stuck car, a vulnerable home, and a stressed-out morning. Maybe your door is off its tracks. Maybe it slams shut the moment you let go. Maybe it just won't budge. Whatever the issue, continuing to force it risks serious injury and expensive secondary damage to panels, cables, and the opener motor. Our licensed technicians diagnose the real problem in minutes, carry the parts to fix it on the first visit, and get your door moving safely again - usually the same day you call. No guesswork. No upsells. Just a working door, fast.",
    whatWeFix: [
      "Doors off their tracks or jammed",
      "Broken, frayed, or snapped cables",
      "Bent, dented, or cracked panels",
      "Noisy, grinding, or vibrating doors",
      "Doors that reverse before closing",
      "Damaged rollers, hinges, and brackets",
      "Weather seal and bottom gasket replacement",
      "Emergency storm and collision damage",
    ],
    urgencyTriggers: [
      "Your door is stuck open and your home is unsecured",
      "You hear a loud bang or snap when operating the door",
      "Cables are hanging loose or frayed",
      "The door is crooked or tilting to one side",
      "Panels are bent, dented, or separating",
    ],
    faqs: [
      {
        q: "How fast can you get to my home?",
        a: "Most GTA calls are on-site within 45-60 minutes. We dispatch the nearest available licensed technician the moment you call.",
      },
      {
        q: "Can you fix any brand of garage door?",
        a: "Yes. We service every major brand including Clopay, Wayne Dalton, Amarr, Richards-Wilcox, Garaga, Raynor, and more. Our trucks are stocked with universal parts.",
      },
      {
        q: "Is it safe to keep using a damaged door?",
        a: "No. A door with broken cables, cracked springs, or off-track panels can fall suddenly and cause serious injury. Stop using it and call us immediately.",
      },
      {
        q: "Do you offer same-day repair?",
        a: "Yes. The vast majority of repair calls are completed the same day, on the first visit, because our trucks carry the parts we need.",
      },
    ],
  },
  {
    slug: "garage-door-spring-replacement",
    name: "Garage Door Spring Replacement",
    shortDesc: "Torsion and extension spring replacement, same day.",
    icon: "Spiral",
    image:
      "https://images.unsplash.com/photo-1652469281665-0ea785b9f743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NTZ8MHwxfHNlYXJjaHwxfHxnYXJhZ2UlMjBkb29yJTIwaW5zdGFsbGF0aW9uJTIwaG91c2V8ZW58MHx8fHwxNzc3NTY4NDM1fDA&ixlib=rb-4.1.0&q=85",
    metaTitle: "Garage Door Spring Replacement GTA | Same Day",
    metaDescription:
      "Broken torsion or extension spring? Don't risk it. Our techs replace garage door springs safely across the GTA. Call for same-day service.",
    intro:
      "If you heard a loud bang in the garage and now your door won't lift, a spring just snapped. Garage door springs carry the entire weight of the door under extreme tension - when they fail, they fail hard. Trying to lift the door manually, or replace the spring yourself, is how people end up in the ER. We replace torsion and extension springs safely with the correct wire gauge, length, and cycle rating for your specific door. Most spring jobs are completed in under an hour. We always replace springs in matched pairs so you're not back on the phone in three months.",
    whatWeFix: [
      "Snapped or broken torsion springs",
      "Worn or stretched extension springs",
      "Unbalanced doors that won't hold position",
      "Undersized springs installed by previous companies",
      "Cable drum and shaft damage from spring failure",
      "Matched pair replacements (highly recommended)",
      "High-cycle upgrade springs for frequent use",
      "Full safety cable installation",
    ],
    urgencyTriggers: [
      "You heard a loud bang and now the door feels extremely heavy",
      "A visible gap or separation in the spring above the door",
      "The door opens crooked or only goes up a few inches",
      "The opener strains, reverses, or makes grinding noise",
      "A spring is hanging loose or the cable has dropped",
    ],
    faqs: [
      {
        q: "Why should I replace both springs if only one broke?",
        a: "The second spring has the exact same age and cycle count. Replacing only one means you'll be calling us again in a few weeks. Matched-pair replacement saves money and prevents door damage.",
      },
      {
        q: "Can I just lift the door manually until you arrive?",
        a: "Not safely. A door with a broken spring can weigh 200+ lbs and drop suddenly. Leave it alone and call us - we'll be there fast.",
      },
      {
        q: "How long do new springs last?",
        a: "Standard springs are rated for around 10,000 cycles (roughly 7-10 years of normal use). We also offer high-cycle 20,000 and 30,000 cycle springs for busy households.",
      },
      {
        q: "Do you carry springs in stock?",
        a: "Yes. Our trucks carry the most common residential torsion and extension springs so we can complete the job on the first visit.",
      },
    ],
  },
  {
    slug: "garage-door-installation",
    name: "Garage Door Installation",
    shortDesc: "New door supply and installation across the GTA.",
    icon: "HouseLine",
    image:
      "https://images.unsplash.com/photo-1652469281665-0ea785b9f743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NTZ8MHwxfHNlYXJjaHwxfHxnYXJhZ2UlMjBkb29yJTIwaW5zdGFsbGF0aW9uJTIwaG91c2V8ZW58MHx8fHwxNzc3NTY4NDM1fDA&ixlib=rb-4.1.0&q=85",
    metaTitle: "Garage Door Installation GTA | Supply & Install",
    metaDescription:
      "New garage door supply and installation across Toronto and the GTA. Steel, wood, insulated - all styles. Call GTA Garage Doors today.",
    intro:
      "A new garage door is the single biggest upgrade you can make to the front of your home. It's also one of the most important security and insulation investments you'll make. We supply and install steel, wood, composite, and fully insulated garage doors from the brands we trust - built to survive GTA winters and look sharp for a decade. Our quotes are flat-rate, all-in, and include removal and disposal of your old door. No surprise charges. No slow-walking the install. Most single-door installs are done in under four hours, start to finish.",
    whatWeFix: [
      "Single and double garage door supply and install",
      "Insulated R-16 and R-18 energy-efficient doors",
      "Carriage house, modern, and traditional styles",
      "Steel, wood, and composite material options",
      "Custom sizing and non-standard openings",
      "Old door removal and disposal included",
      "Full hardware, track, and spring replacement",
      "Matching opener install available",
    ],
    urgencyTriggers: [
      "Your current door has visible rust, rot, or panel damage",
      "Cold air is pouring into your garage all winter",
      "The door is 15+ years old and failing frequently",
      "You're selling your home and need curb appeal fast",
      "Your door was damaged in a collision or storm",
    ],
    faqs: [
      {
        q: "How long does installation take?",
        a: "Most single-door installs take 3-4 hours. Double-door installs take 4-6 hours. We do the full job in one visit.",
      },
      {
        q: "Do you remove my old door?",
        a: "Yes. Removal and disposal of your old door is included in every install - no extra charges.",
      },
      {
        q: "What brands do you install?",
        a: "We install Clopay, Garaga, Richards-Wilcox, Amarr, and Wayne Dalton as our primary brands. We can also source specialty brands on request.",
      },
      {
        q: "Do I need a new opener with my new door?",
        a: "Not always. If your opener is under 10 years old and working well, we'll reinstall it. If it's older or underpowered for the new door, we'll let you know in advance and install a replacement.",
      },
    ],
  },
  {
    slug: "door-repair-installation",
    name: "Door Repair & Installation",
    shortDesc: "Front, back, and side residential door work.",
    icon: "Door",
    image:
      "https://images.pexels.com/photos/34286675/pexels-photo-34286675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    metaTitle: "Front, Back & Side Door Repair GTA | Fast Service",
    metaDescription:
      "Damaged or broken residential door? We repair and replace front, back, and side doors across the GTA. Same-day emergency service available.",
    intro:
      "Your front door isn't just a door - it's the main security point of your home and the first thing anyone sees. A sagging frame, a door that won't latch, a cracked panel, or damage from a break-in attempt leaves your house exposed. We repair and replace residential entry doors, back doors, side doors, and patio doors across the GTA. Same-day emergency service is available when the door is compromised. We carry frames, jambs, hinges, strike plates, and weatherstripping on the truck so most repairs are completed on the first visit.",
    whatWeFix: [
      "Damaged or rotting door frames and jambs",
      "Doors that won't close, latch, or lock",
      "Cracked, split, or kicked-in panels",
      "Sagging or binding doors",
      "Weather seal and threshold replacement",
      "New entry door supply and installation",
      "Deadbolt and strike plate reinforcement",
      "Emergency boarding and secure-up after damage",
    ],
    urgencyTriggers: [
      "Your door won't close or latch properly",
      "Visible cracks, kicks, or splits in the door or frame",
      "Daylight is visible around the closed door",
      "The lock is bypassed, loose, or spinning freely",
      "The door was involved in a break-in attempt",
    ],
    faqs: [
      {
        q: "My door was kicked in - can you secure it today?",
        a: "Yes. We carry replacement jambs, strike plates, and reinforcement kits on the truck. We can secure and fully restore most kicked-in doors on the same day.",
      },
      {
        q: "Do you install new entry doors?",
        a: "Yes. We supply and install steel, fiberglass, and wood entry doors, plus matching storm doors, from trusted Canadian brands.",
      },
      {
        q: "Can you reinforce my door against break-ins?",
        a: "Absolutely. We install heavy-duty strike plates, 3-inch screws into the framing stud, Door Armor kits, and deadbolt upgrades - all proven break-in deterrents.",
      },
      {
        q: "Is this covered by home insurance after a break-in?",
        a: "Usually yes. We provide a detailed, itemized invoice that almost every GTA insurer will accept for claim reimbursement.",
      },
    ],
  },
  {
    slug: "locksmith-services",
    name: "Locksmith Services",
    shortDesc: "Locked out? We're on our way.",
    icon: "Key",
    image:
      "https://images.pexels.com/photos/34286675/pexels-photo-34286675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    metaTitle: "Locksmith Toronto & GTA | Fast, Licensed Locksmiths",
    metaDescription:
      "Locked out of your home? Need a lock change or rekey? GTA's licensed locksmiths respond fast, 24/7. Call now for immediate service.",
    intro:
      "Standing outside your own house at midnight, in the cold, is no fun. Neither is a lock that jams in -20 weather. Our licensed locksmiths cover every corner of the GTA 24 hours a day, 7 days a week - including weekends, holidays, and the middle of the night. We pick, unlock, rekey, or replace residential locks without damaging your door. You'll usually see us pulling up within 30-45 minutes of your call. We carry Schlage, Kwikset, Weiser, Medeco, and Mul-T-Lock on the truck so you walk back into a secure, working home the same visit.",
    whatWeFix: [
      "Emergency lockouts (home, garage, shed, mailbox)",
      "Lock picking with zero door damage",
      "Lock rekeying (change the key without changing the lock)",
      "Deadbolt and smart lock installation",
      "Broken key extraction from locks",
      "High-security lock upgrades (Medeco, Mul-T-Lock)",
      "Garage side-door and shed lock replacement",
      "24/7 emergency response GTA-wide",
    ],
    urgencyTriggers: [
      "You're locked out right now",
      "Your key broke off inside the lock",
      "The lock is frozen, jammed, or spinning",
      "You just lost your keys or a tenant moved out",
      "You had a break-in attempt and need immediate rekey",
    ],
    faqs: [
      {
        q: "Will you damage my lock to get me in?",
        a: "No. Our locksmiths are trained to pick, bypass, or bump most residential locks non-destructively. Drilling is a last resort and only with your permission.",
      },
      {
        q: "How do I know you're legitimate?",
        a: "Every locksmith arrives in a marked truck with photo ID and a licensed-and-insured badge. We provide a written invoice with our business name, address, and phone.",
      },
      {
        q: "What do you need to prove the home is mine?",
        a: "Photo ID matching the service address (driver's licence, lease, utility bill, or mortgage document). This protects you and your neighbours.",
      },
      {
        q: "Do you service weekends and holidays?",
        a: "Yes. 24/7, 365 days a year. Real licensed technicians on real service trucks, any hour you call.",
      },
    ],
  },
  {
    slug: "emergency-break-in-repair",
    name: "Emergency Break-In Repair",
    shortDesc: "Door kicked in? We secure your home fast.",
    icon: "Warning",
    image:
      "https://images.pexels.com/photos/34286675/pexels-photo-34286675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    metaTitle: "Emergency Break-In Repair GTA | 24/7 Response",
    metaDescription:
      "Door kicked in or lock forced? We repair break-in damage fast across the GTA - door frames, locks, and hardware. Call now for emergency service.",
    intro:
      "If you're reading this because someone just broke into your home, call us first - police second. We can have a tech on-site in under an hour, day or night, to secure your door, replace the lock, and reinforce the frame before you go to sleep tonight. Our emergency board-up crew carries full kits: replacement jambs, heavy-duty strike plates, new deadbolts, fresh keys, and reinforcement hardware. Most break-in repairs are fully completed in one visit - your home is locked, secured, and stronger than it was before the attempt.",
    whatWeFix: [
      "Kicked-in or pried door frames",
      "Split, cracked, and broken jambs",
      "Forced or drilled deadbolts and locks",
      "Emergency lock replacement and rekey",
      "Reinforced strike plates with 3-inch screws",
      "Full Door Armor and anti-kick kit installs",
      "Emergency board-up if door cannot be saved",
      "Insurance-ready itemized invoices",
    ],
    urgencyTriggers: [
      "Your door was just kicked in or forced open",
      "You came home to a damaged frame or spun cylinder",
      "The lock turns but doesn't engage anymore",
      "You can see daylight through a splintered jamb",
      "You're home alone and don't feel safe",
    ],
    faqs: [
      {
        q: "How fast can you get here?",
        a: "45-60 minutes in almost every GTA neighbourhood, day or night. We prioritize break-in calls above all other service types.",
      },
      {
        q: "Should I call the police first?",
        a: "Call 911 first if you think the intruder may still be inside or nearby. Once the scene is clear, call us - we'll be on the way while you speak to the officer.",
      },
      {
        q: "Can I file an insurance claim for this?",
        a: "Almost always yes. Most GTA home insurance policies cover break-in damage. We provide a detailed, itemized invoice that works directly with insurers.",
      },
      {
        q: "Can you reinforce so it doesn't happen again?",
        a: "Yes. We install heavy-duty strike plates, 3-inch framing screws, Door Armor kits, and upgraded deadbolts as part of the same visit. Most of our break-in customers never have another incident.",
      },
    ],
  },
  {
    slug: "lock-change-rekey",
    name: "Lock Change & Rekey",
    shortDesc: "New locks after a move, break-in, or lost keys.",
    icon: "Lock",
    image:
      "https://images.pexels.com/photos/34286675/pexels-photo-34286675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    metaTitle: "Lock Change & Rekey Toronto | GTA Locksmith",
    metaDescription:
      "New locks or rekey after a break-in, move, or lost key? Fast, professional lock change service across Toronto and the GTA. Call us today.",
    intro:
      "Moving into a new GTA home? Just lost a set of keys? Had a tenant move out and want peace of mind? You don't always need to buy new locks - a rekey is faster and cheaper. We re-pin the cylinder so your old keys stop working and one new key opens every lock in the house. If the locks are worn, outdated, or low-quality, we'll swap them for Schlage, Kwikset, Weiser, or a smart lock of your choice. Most full-house jobs are completed in one 45-60 minute visit. Every key matches every lock. Clean. Simple. Secure.",
    whatWeFix: [
      "Full-house rekey (all locks to one new key)",
      "Lock replacement with new hardware",
      "Smart lock installation (August, Schlage Encode, Yale)",
      "Matching deadbolts and knob sets",
      "Master key setup for landlords",
      "Mailbox and shed lock rekey",
      "Lock cylinder upgrades to high-security",
      "New keys cut on the spot",
    ],
    urgencyTriggers: [
      "You just closed on a new GTA home",
      "A tenant or roommate moved out and kept a key",
      "You lost a key or your wallet with keys inside",
      "Your old locks are worn, sticky, or low-grade",
      "You want one key for every door in the house",
    ],
    faqs: [
      {
        q: "What's the difference between a rekey and a lock change?",
        a: "A rekey keeps your existing lock hardware and just changes which key operates it - cheaper and fast. A lock change swaps the entire lock for new hardware - better if the lock is old, worn, or low security.",
      },
      {
        q: "Can you make all my locks use the same key?",
        a: "Yes. Full-house rekeys are the most popular job we do - one key operates every door, including back doors and side doors.",
      },
      {
        q: "Do I need to be there for the rekey?",
        a: "Someone authorized does, yes. We need photo ID matching the address to protect you and your neighbours.",
      },
      {
        q: "Do you install smart locks?",
        a: "Yes. We install and set up Schlage Encode, August, Yale Assure, and most other popular smart locks - including Wi-Fi setup and keypad programming.",
      },
    ],
  },
  {
    slug: "garage-door-opener-repair",
    name: "Garage Door Opener Repair",
    shortDesc: "All major brands fixed, same day.",
    icon: "Gear",
    image:
      "https://images.unsplash.com/photo-1739203469638-d6f54c24a5da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxnYXJhZ2UlMjBkb29yJTIwcmVwYWlyJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3Nzc1Njg0MTR8MA&ixlib=rb-4.1.0&q=85",
    metaTitle: "Garage Door Opener Repair GTA | All Brands Fixed",
    metaDescription:
      "Garage door opener not working? We repair all major brands across the GTA - Chamberlain, LiftMaster, Genie, and more. Same-day service available.",
    intro:
      "The opener hums but the door doesn't move. The remote works sometimes. The keypad is dead. The door reverses halfway down. These are all classic opener problems - and almost none of them mean you need a new unit. Most repairs come down to worn gears, misaligned safety sensors, a bad logic board, or dead capacitors. We service every major opener brand - Chamberlain, LiftMaster, Genie, Craftsman, Linear, Marantec, and Skylink - and we carry parts for the most common models on the truck. If your opener is past saving, we'll replace it with a quiet belt-drive unit that outlasts your car.",
    whatWeFix: [
      "Opener won't respond to remote or keypad",
      "Door reverses before fully closing",
      "Safety sensor alignment and replacement",
      "Worn gear, sprocket, and chain repair",
      "Noisy, grinding, or slow-moving openers",
      "Remote and keypad reprogramming",
      "Full opener replacement (belt, chain, or screw drive)",
      "Smart / Wi-Fi opener installation (MyQ, Aladdin)",
    ],
    urgencyTriggers: [
      "Your door is stuck open and you can't close it",
      "The motor runs but the door doesn't move",
      "You hear a grinding or popping noise from the unit",
      "The opener is older than 15 years",
      "Remotes and keypad both stopped working at once",
    ],
    faqs: [
      {
        q: "My opener is old - should I repair or replace?",
        a: "Rule of thumb: if the unit is under 12 years old and the repair is minor, repair it. Over 15 years or multiple recent failures, replace. We'll give you both options on-site so you can choose.",
      },
      {
        q: "Do you program new remotes?",
        a: "Yes. We program and replace remotes for every major brand, including universal remotes if yours is discontinued.",
      },
      {
        q: "Why does my door reverse before closing?",
        a: "Nine times out of ten it's the photo-eye safety sensors - they're misaligned, dirty, or have a broken wire. We fix this in minutes.",
      },
      {
        q: "What's the quietest opener you install?",
        a: "Belt-drive openers (LiftMaster 8550W, Chamberlain B6753T) are the quietest - ideal if there's a bedroom above the garage.",
      },
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
find((s) => s.slug === slug);
